import { render, staticRenderFns } from "./Shared.vue?vue&type=template&id=0cbf07f4&"
import script from "./Shared.vue?vue&type=script&lang=js&"
export * from "./Shared.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports